import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Button } from '../../components';

const Forbidden = () => {
  return (
    <div className="section-gap">
      <Card>
        <div className="text-center py-16">
          <div className="w-24 h-24 bg-warning/20 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg className="w-12 h-12 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          
          <h1 className="text-6xl font-bold text-text mb-4">403</h1>
          <h2 className="text-2xl font-semibold text-text mb-4">Access Forbidden</h2>
          <p className="text-muted text-lg mb-8 max-w-md mx-auto">
            You don't have permission to access this resource. Please contact your administrator if you believe this is an error.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/app/dashboard/founder">
              <Button variant="primary" size="lg" className="px-8">
                Go to Dashboard
              </Button>
            </Link>
            <Button 
              variant="ghost" 
              size="lg" 
              className="px-8"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
          </div>
          
          <div className="mt-12 pt-8 border-t border-line">
            <p className="text-muted text-sm mb-4">You might be looking for:</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/app/lms/courses" className="text-chart hover:text-text transition-colors text-sm">
                Courses
              </Link>
              <Link to="/app/mentors" className="text-chart hover:text-text transition-colors text-sm">
                Mentors
              </Link>
              <Link to="/app/program/timeline" className="text-chart hover:text-text transition-colors text-sm">
                Program Timeline
              </Link>
              <Link to="/app/startup" className="text-chart hover:text-text transition-colors text-sm">
                My Startup
              </Link>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Forbidden;
